const REQUEST_MEDIA_AVAILABILITIES = '@@mediaAvailabilities/REQUEST_MEDIA_AVAILABILITIES';
const MEDIA_AVAILABILITIES_RESPONSE = '@@mediaAvailabilities/MEDIA_AVAILABILITIES_RESPONSE';;

export default {
    REQUEST_MEDIA_AVAILABILITIES,
    MEDIA_AVAILABILITIES_RESPONSE,
};